import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useCreateScript } from "@/data/use-scripts-data";
import { useGroupSlug } from "@/hooks/use-group-slug";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";

export default function ScriptCreatePage() {
  const groupUuid = useGroupUuid();
  const groupSlug = useGroupSlug();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const { createScript, isCreating } = useCreateScript(groupUuid);

  async function handleCreate() {
    if (!name.trim()) {
      toast.error("Please enter a script name");
      return;
    }

    try {
      const script = await createScript({
        name: name.trim(),
        content: "",
      });

      // Navigate to edit page
      if (script?.uuid) {
        navigate({
          to: "/w/$groupSlug/settings/script/$scriptUuid",
          params: { groupSlug, scriptUuid: script.uuid },
        });
      }
    } catch (error) {
      console.error("Failed to create script:", error);
    }
  }

  return (
    <Page>
      <PageHeader>
        <PageHeader.Title>Create Interview Script</PageHeader.Title>
      </PageHeader>
      <PageBody>
        <div className="mx-auto max-w-2xl space-y-6">
          <div className="space-y-2">
            <Label htmlFor="script-name">Script Name *</Label>
            <Input
              id="script-name"
              placeholder="e.g., Technical Interview - Senior Engineer"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && name.trim()) {
                  handleCreate();
                }
              }}
              autoFocus
            />
            <p className="text-muted-foreground text-sm">
              Give your script a descriptive name. You'll be able to add the
              content in the next step.
            </p>
          </div>

          <div className="flex gap-2">
            <Button
              onClick={handleCreate}
              disabled={isCreating || !name.trim()}
            >
              {isCreating ? "Creating..." : "Create Script"}
            </Button>
            <Button
              variant="outline"
              onClick={() =>
                navigate({
                  to: "/w/$groupSlug/settings/interviews",
                  params: { groupSlug },
                })
              }
            >
              Cancel
            </Button>
          </div>
        </div>
      </PageBody>
    </Page>
  );
}
